import JSZip from 'jszip';

/**
 * Extract watchlist.csv content from a Letterboxd ZIP export.
 *
 * @param zipData - The raw ZIP file as an ArrayBuffer
 * @returns The CSV content as a string
 * @throws Error if the ZIP doesn't contain a watchlist.csv
 */
export async function extractWatchlistCsvFromZip(
  zipData: ArrayBuffer
): Promise<string> {
  const zip = await JSZip.loadAsync(zipData);
  const watchlistFile = zip.file('watchlist.csv');

  if (!watchlistFile) {
    throw new Error(
      'No watchlist.csv found in the ZIP file. Make sure this is a Letterboxd data export.'
    );
  }

  return watchlistFile.async('string');
}
